import { Controller } from "@hotwired/stimulus"

// Drop (or pick) images, upload each to `url` with a progress bar, then
// refresh the page. Caption defaults to the filename.
export default class extends Controller {
  static targets = ["input", "zone", "progress", "bar", "label"]
  static values = { url: String }

  browse() { this.inputTarget.click() }
  picked() { this.upload(this.inputTarget.files) }

  over(event) {
    event.preventDefault()
    this.zoneTarget.classList.add("dropzone-active")
  }

  leave() { this.zoneTarget.classList.remove("dropzone-active") }

  drop(event) {
    event.preventDefault()
    this.leave()
    this.upload(event.dataTransfer.files)
  }

  async upload(fileList) {
    const files = Array.from(fileList).filter((f) => f.type.startsWith("image/"))
    if (!files.length) return

    this.progressTarget.hidden = false
    let failed = 0
    for (const [i, file] of files.entries()) {
      this.labelTarget.textContent = `Uploading ${i + 1} of ${files.length}: ${file.name}`
      try { await this.send(file) } catch { failed++ }
    }

    if (failed) {
      this.labelTarget.textContent = `${failed} of ${files.length} failed to upload.`
      this.barTarget.classList.add("bg-danger")
      setTimeout(() => this.refresh(), 2500)
    } else {
      this.refresh()
    }
  }

  send(file) {
    return new Promise((resolve, reject) => {
      const data = new FormData()
      data.append("gallery_image[image]", file)
      data.append("gallery_image[caption]", file.name.replace(/\.[^.]+$/, "").replace(/[-_]+/g, " "))

      const xhr = new XMLHttpRequest()
      xhr.open("POST", this.urlValue)
      xhr.setRequestHeader("X-CSRF-Token", document.querySelector('meta[name="csrf-token"]').content)
      xhr.setRequestHeader("Accept", "application/json")
      xhr.upload.onprogress = (e) => {
        if (!e.lengthComputable) return
        const pct = Math.round((e.loaded / e.total) * 100)
        this.barTarget.style.width = `${pct}%`
        this.barTarget.textContent = `${pct}%`
      }
      xhr.onload = () => (xhr.status < 300 ? resolve() : reject())
      xhr.onerror = reject
      xhr.send(data)
    })
  }

  refresh() {
    window.Turbo ? window.Turbo.visit(window.location.href, { action: "replace" }) : window.location.reload()
  }
}
